import React from "react";
import PropTypes from "prop-types";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Config from "conFig.js";

const Capnhattrungtam = React.memo(function Capnhattrungtam(props) {
  const { id } = props;
  const [ten, setTen] = React.useState("");
  const [coquanquanly, setCoquanquanly] = React.useState("");
  const [hangxesathach, setHangxesathach] = React.useState("");
  const [diachi, setDiachi] = React.useState("");
  const [dienthoai, setDienthoai] = React.useState("");
  const [loaitrungtam, setLoaitrungtam] = React.useState("");
  const [thutruongdonvi, setThutruongdonvi] = React.useState("");
  const [maytinhsathach, setMaytinhsathach] = React.useState("");
  const [xesathach, setXesathach] = React.useState("");
  const [alert, setAlert] = React.useState(false);
  const [alert1, setAlert1] = React.useState(false);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getthongtin = () => {
    var url =
      Config.backend +
      "/api/CoSoGTVT/gettrungtamsathachtheoid?id=" +
      id +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setTen(data[0].ten);
        setCoquanquanly(data[0].coquanquanly);
        setHangxesathach(data[0].hangxesathach);
        setDiachi(data[0].diachi);
        setThutruongdonvi(data[0].thutruongdonvi);
        setMaytinhsathach(data[0].maytinhsathach);
        setDienthoai(data[0].dienthoai);
        setXesathach(data[0].xesathach);
        setLoaitrungtam(data[0].loaitrungtam);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const capnhat = () => {
    var url = Config.backend + "/api/CoSoGTVT/capnhatttsathach";
    fetch(url, {
      method: "PUT",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        id: id,
        ten: ten,
        coquanquanly: coquanquanly,
        hangxesathach: hangxesathach,
        diachi: diachi,
        dienthoai: dienthoai,
        thutruongdonvi: thutruongdonvi,
        maytinhsathach: maytinhsathach,
        xesathach: xesathach,
        loaitrungtam: loaitrungtam,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data === 1) {
          showNotification();
        } else showNotification1();
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  const showNotification1 = () => {
    setAlert1(true);
    setTimeout(function () {
      setAlert1(false);
    }, 2000);
  };
  React.useEffect(() => {
    getthongtin();
  }, []);
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <TextField
                label="Tên trung tâm"
                variant="outlined"
                size="small"
                value={ten}
                onChange={(event) => {
                  setTen(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <TextField
                label="Loại trung tâm"
                variant="outlined"
                size="small"
                value={loaitrungtam}
                onChange={(event) => {
                  setLoaitrungtam(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <TextField
                label="Địa chỉ"
                variant="outlined"
                size="small"
                value={diachi}
                onChange={(event) => {
                  setDiachi(event.target.value);
                }}
                multiline
                rows={3}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <TextField
                label="Số điện thoại"
                variant="outlined"
                size="small"
                value={dienthoai}
                onChange={(event) => {
                  setDienthoai(event.target.value);
                }}
                multiline
                rows={3}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <TextField
                label="Cơ quan quản lý trực tiếp"
                variant="outlined"
                size="small"
                value={coquanquanly}
                onChange={(event) => {
                  setCoquanquanly(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <TextField
                label="Thủ trưởng đơn vị"
                variant="outlined"
                size="small"
                value={thutruongdonvi}
                onChange={(event) => {
                  setThutruongdonvi(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <TextField
                label="Hạng xe sát hạch"
                variant="outlined"
                size="small"
                value={hangxesathach}
                onChange={(event) => {
                  setHangxesathach(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <TextField
                label="Số lượng máy tính sát hạch"
                variant="outlined"
                size="small"
                value={maytinhsathach}
                onChange={(event) => {
                  setMaytinhsathach(event.target.value);
                }}
                multiline
                rows={3}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <TextField
                label="Số lượng xe sát hạch"
                variant="outlined"
                size="small"
                value={xesathach}
                onChange={(event) => {
                  setXesathach(event.target.value);
                }}
                multiline
                rows={3}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
      </CardBody>
      {/** fix css */}
      <CardFooter style={{ marginBottom: "30px" }}>
        <Button
          color="primary"
          variant="contained"
          style={{ height: 27 }}
          onClick={capnhat}
        >
          Cập nhật
        </Button>
      </CardFooter>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Cập nhật thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message="Có lỗi trong quá trình cập nhật"
            open={alert1}
            closeNotification={() => setAlert1(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
});

Capnhattrungtam.propTypes = {
  id: PropTypes.number,
};
export default Capnhattrungtam;
